<template>
    <v-dialog v-model="abrirDialogo" :max-width="tamModal" :fullscreen="$root.isTouch" :scrollable="$root.isTouch == false" persistent>
        <v-card>
            <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="titulo"></span></v-card-title>
            <v-card-text>
                <v-container fluid grid-list-md>

                    <!-- Modal Rangos -->
                    <v-dialog v-model="objModalRango.abrirDialogo" :max-width="width" :fullscreen="$root.isTouch"
                        :scrollable="$root.isTouch == false" persistent>
                        <v-card>
                            <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="objModalRango.titulo"></span></v-card-title>
                            <v-container fluid grid-list-md>
                                <v-form ref="form_modal_rango">
                                    <v-row dense>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-autocomplete label="Cobertura *" color="textbox" v-model="objModalRango.idCoberturaNueva"
                                                :items="listGeneral.listCoberturasModal" item-text="cobertura"
                                                item-value="idCobertura" :rules="requeridoRegla"
                                                outlined dense />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field label="Valor de Cobertura *" color="textbox" v-model="objModalRango.valor"
                                                :rules="!_.isUndefined(objModalRango.idCoberturaNueva) ? _.concat(requeridoRegla,decimal) : []"
                                                outlined dense />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field label="Rango Inicial *" color="textbox" v-model="objModalRango.rangoInicial"
                                                :rules="!_.isUndefined(objModalRango.idCoberturaNueva)  ? _.concat(requeridoRegla,decimal) : []"
                                                outlined dense />
                                        </v-col>
                                    <!-- </v-row>
                                    <v-row dense> -->
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field label="Rango Final *" color="textbox" v-model="objModalRango.rangoFinal"
                                                :rules="!_.isUndefined(objModalRango.idCoberturaNueva) ? _.concat(requeridoRegla,decimal) : []"
                                                outlined dense />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field label="Intervalo *" color="textbox" v-model="objModalRango.intervalo"
                                                :rules="!_.isUndefined(objModalRango.idCoberturaNueva) ? _.concat(requeridoRegla,decimal) : []"
                                                outlined dense />   
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-autocomplete label="Clasificación Cobertura *" color="textbox" v-model="objModalRango.idClasificacionCob" :items="listGeneral.listClasificacion"
                                                item-text="clasificacionCob" item-value="idClasificacionCob" :rules="!_.isUndefined(objModalRango.idCoberturaNueva) ? requeridoRegla : []"
                                                outlined dense />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-autocomplete label="Estado *" color="textbox" v-model="objModalRango.idEstado" :items="listGeneral.listaEstadosModal"
                                                item-text="nombre_estado" item-value="id_estado" :rules="requeridoRegla"
                                                outlined dense />
                                        </v-col>
                                    </v-row>
                                    <v-row xs12>
                                        <v-col class="text-right">
                                            <v-btn outlined rounded class="mr-1" @click="objModalRango = { titulo: 'Nuevo Rango', abrirDialogo: false , idEstado : '1'}">Cancelar</v-btn>
                                            <v-btn rounded dark color="primary" @click="guardarModalRango">Guardar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                    </v-dialog>
                    <!-- Fin Modal Rango -->

                    <v-form ref="form_plan_cobertura">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Aseguradora *" color="textbox" v-model="obPlanCobertura.idAseguradora" :items="listGeneral.listaAseguradora"
                                    item-text="aseguradora" item-value="idAseguradora" @change="onListarProductos"
                                    :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Producto *" color="textbox" v-model="obPlanCobertura.idProducto"
                                    :items="listGeneral.listProductosModal" item-text="nombre_producto"
                                    item-value="id_producto" @change="onListarDetalleCoberturas" :rules="requeridoRegla"
                                    outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Nombre Plan *" color="textbox" v-model="obPlanCobertura.nombre"
                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(1,obPlanCobertura.nombre,300))"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Tipo Plan" color="textbox" v-model="obPlanCobertura.idTipoPlan"
                                    :items="listGeneral.listaTipoPlan" item-text="tipo" item-value="idTipoPlan"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Selección Cobertura Plan" color="textbox"
                                    v-model="obPlanCobertura.idSeleccionCoberturaCliente"
                                    :items="listGeneral.listDecision" item-text="decision" item-value="idDecision"
                                    outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4"/>
                            <v-col cols="12" sm="4"/>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Estado *" color="textbox" v-model="obPlanCobertura.idEstado"
                                    :items="listGeneral.listaEstadosModal" item-text="nombre_estado"
                                    item-value="id_estado" :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-btn rounded dark color="primary" @click="abrirModalRango">Nuevo</v-btn>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Buscar" color="textbox" v-model="obPlanCobertura.busqueda" dense clearable prepend-inner-icon="search" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-data-table :search="obPlanCobertura.busqueda" :headers="listGeneral.subCabecera"
                                    :items="listGeneral.subDetalle" class="elevation-3">

                                    <template v-slot:item.rango_inicial="{ item }">
                                        {{ item.rangoInicial }}   
                                    </template>

                                    <template v-slot:item.rango_final="{ item }">
                                        {{ item.rangoFinal }}   
                                    </template>

                                    <template v-slot:item.rango_intervalo="{ item }">
                                        {{ item.intervalo }}   
                                    </template>

                                    <template v-slot:item.name="{ item }">
                                        <v-btn class="ma-2" text icon color="primary" @click="editarCobertura(item)">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>     
                                    </template>

                                    <template v-slot:no-results>
                                        Tu búsqueda de "<span v-text="obPlanCobertura.busqueda"></span>" no arrojó resultados.
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cerrarModal">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="submit">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        inject: ['insertarActualizar', 'cerrarModal'],
        props: {
            abrirDialogo: {
                type: Boolean,
                default: false
            },
            titulo: {
                type: String,
                default: ''
            },
            objPlanCobertura: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                objModalRango: {
                    titulo: 'Nuevo Rango',
                    abrirDialogo: false,
                    idCoberturaNueva:null,
                    valor:null,
                    rangoInicial:null,
                    rangoFinal:null,
                    intervalo:null,
                    idClasificacionCob:null,
                    idEstado: '1'
                },
                obPlanCobertura: {
                    opcion: 'I',
                    idEstado: '1'
                },
                width:"60%"
            }
        },
        watch: {
            abrirDialogo() {
                if (this.abrirDialogo) {
                    this.cargaGeneral();
                }
            }
        },
        methods: {
            cargaGeneral() {
                this.currentRow = null;
                this.$set(this.listGeneral, 'listDetalleCoberturas', []);
                this.$set(this.listGeneral, 'listProductosModal', []);
                this.$set(this.listGeneral, 'subDetalle', []);
                this.$set(this.listGeneral, 'listaTipoPlan', _.filter(this.listGeneral.listaTipoPlan, (o) => { return _.toUpper(o.visualiza) == _.toUpper('true') }));
                this.$set(this.listGeneral, 'listDecision', _.filter(this.listGeneral.listDecision, (o) => { return _.toUpper(o.visualiza) == _.toUpper('true') }));
                this.$set(this.listGeneral, 'listaEstadosModal', _.filter(this.listGeneral.listEstados, (o) => { return _.toUpper(o.visualiza) == _.toUpper('true') }));

                this.obPlanCobertura = { opcion: 'I', idEstado: _.toString(this.parametros.idEstadoDefault) };
                if (this.objPlanCobertura.opcion != 'I') {
                    this.obPlanCobertura = _.clone(this.objPlanCobertura);
                    this.$set(this.listGeneral, 'listProductosModal', this.listGeneral.listaProductos);
                    this.onListarDetalleCoberturas('e');
                }

                if(!_.isUndefined(this.$refs.form_plan_cobertura))
                    this.$refs.form_plan_cobertura.resetValidation();
            },
            onListar(ruta, objeto, lista) {
                return axios.post(`${BASE_URI}${ruta}`, objeto)
                    .then((respuesta) => {
                        if (respuesta.status != 200) throw mensajeEstandar.errorPeticion;
                        if (respuesta.data.existeError) throw respuesta.data.mensaje;
                        if (_.size(respuesta.data.data) > 0)
                            this.$set(this.listGeneral, lista, respuesta.data.data);
                        else {
                            // sin datos: no conservar el listado de la consulta anterior
                            if (!_.isNull(lista)) this.$set(this.listGeneral, lista, []);
                            mensajesAlerta(respuesta.data.mensaje, 'I');
                        }

                        return respuesta;
                    });
            },
            onListarProductos(e) {
                if (!_.isUndefined(e)) {
                    var objeto = {
                        opcion: 'L_COMBO',
                        idAseguradora: this.obPlanCobertura.idAseguradora,
                        idEstado: this.obPlanCobertura.idEstado
                    };

                    this.$set(this.obPlanCobertura, 'idProducto', null);
                    // if(_.size(this.listGeneral.listProductosModal) == 0)
                    this.onListar('administrador/producto/listar', objeto, 'listProductosModal')
                        .catch((e) => {
                            mensajesAlerta(e, 'E');
                        });
                }
            },
            onListarDetalleCoberturas(e) {
                if (!_.isUndefined(e)) {
                    this.$set(this.listGeneral, 'listDetalleCoberturas', []);
                    this.$set(this.listGeneral, 'subDetalle', []);
                    if (_.size(this.listGeneral.listProductosModal) > 0) {
                        this.obPlanCobertura.idSeguro = _.get(_.find(this.listGeneral.listProductosModal, (ob) => { return parseInt(ob.id_producto) == parseInt(this.obPlanCobertura.idProducto) }), 'id_seguro', null);
                    }

                    var objeto = {
                        opcion: 'DETALLE',
                        idPlanProducto: _.size(this.obPlanCobertura.idPlanProducto) > 0 ? this.obPlanCobertura.idPlanProducto : null,
                        idProducto: this.obPlanCobertura.idProducto,
                        idTipoPlan: this.obPlanCobertura.idTipoPlan,
                        idEstado: this.obPlanCobertura.idEstado
                    };

                    this.onListar('administrador/planCobertura/listar', objeto, 'listDetalleCoberturas')
                        .then((respuesta) => {
                            this.$set(this.listGeneral, 'subDetalle', []);
                            _.forEach(respuesta.data.data, (dato, key) => {
                                this.listGeneral.subDetalle.push({
                                    idPlanProducto: !_.isUndefined(dato['id_plan_producto']) ? dato['id_plan_producto'] : null,
                                    idCobertura: dato['id_cobertura'],
                                    idCoberturaNueva: dato['id_cobertura'],
                                    cobertura: dato['cobertura'],
                                    definicion: '',
                                    valor: parseFloat(dato['valor_cobertura']).toFixed(2),
                                    rangoInicial: parseFloat(dato['rango_inicial']).toFixed(2),
                                    rangoFinal: parseFloat(dato['rango_final']).toFixed(2),
                                    intervalo: parseFloat(dato['rango_intervalo']).toFixed(2),
                                    idClasificacionCob: dato['idClasificacionCob'],
                                    estado: dato['estado'],
                                    idEstado: dato['id_estado']
                                });
                            });
                        }).catch((e) => {
                            mensajesAlerta(e, 'E');
                        });
                }
            },
            submit() {
                try {
                    if (!this.$refs.form_plan_cobertura.validate()) throw mensajeEstandar.corregirInformacion;
                    if (_.size(this.listGeneral.subDetalle) == 0) throw mensajeEstandar.seleccionarCoberturasBasicas;
                    if (!this.validarCoberturasBasicas()) throw mensajeEstandar.seleccionarCoberturasBasicas;
                        var decision = _.find(this.listGeneral.listDecision, (ob) => { return parseInt(ob.idDecision) == parseInt(this.obPlanCobertura.idSeleccionCoberturaCliente) });

                        this.obPlanCobertura.seleccionCoberturaCliente = _.size(decision) > 0 ? decision.decision : 'NO';
                        this.insertarActualizar(this.obPlanCobertura);
                } catch (e) {
                    mensajesAlerta(e, 'I');
                }

            },
            validarCoberturasBasicas() {
                var listaCoberturasBasicas = _.map((_.filter(this.listGeneral.listCoberturasModal, (ob) => { return parseInt(ob.id_tipo) == parseInt(this.parametros.idTipoCoberturaBasica) })), "idCobertura");

                return _.filter(this.listGeneral.subDetalle, (o) => { return _.includes(listaCoberturasBasicas, o.idCoberturaNueva); }).length == listaCoberturasBasicas.length ? true : false;
            },
            editarCobertura(objeto) {
                this.objModalRango = _.merge({}, this.objModalRango, objeto);
                this.objModalRango.index = _.findIndex(this.listGeneral.subDetalle, (ob) => { return _.isEqual(ob, objeto) });
                this.objModalRango.titulo = 'Editar Rango';

                var objeto = {
                    opcion: 'L_COMBO',
                    idAseguradora: this.obPlanCobertura.idAseguradora,
                    idSeguro: this.obPlanCobertura.idSeguro,
                    idEstado: this.parametros.idEstadoDefault
                };

                this.onListar('administrador/cobertura/listar', objeto, 'listCoberturasModal')
                    .then((respuesta) => {
                        if (_.size(respuesta.data.data) > 0)
                            this.objModalRango.abrirDialogo = true;
                    }).catch((e) => {
                        mensajesAlerta(e, 'E')
                    });
            },
            // Modal Rango
            abrirModalRango() {
                if (!_.isUndefined(this.obPlanCobertura.idProducto) && !_.isNull(this.obPlanCobertura.idProducto)) {
                    var objeto = {
                        opcion: 'L_COMBO',
                        idAseguradora: this.obPlanCobertura.idAseguradora,
                        idSeguro: this.obPlanCobertura.idSeguro,
                        idEstado: '1'
                    };

                    this.onListar('administrador/cobertura/listar', objeto, 'listCoberturasModal')
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) > 0)
                                this.objModalRango.abrirDialogo = true;
                            else
                                this.objModalRango = {
                                    titulo: 'Nuevo Rango',
                                    abrirDialogo: false,
                                    idCoberturaNueva:null,
                                    valor:null,
                                    rangoInicial:null,
                                    rangoFinal:null,
                                    intervalo:null,
                                    idClasificacionCob:null,
                                    idEstado: _.toString(this.parametros.idEstadoDefault)
                                };
                        })
                        .catch((e) => {
                            mensajesAlerta(e, 'E')
                        });
                } else
                    mensajesAlerta(mensajeEstandar.seleccionarProducto, 'I');
            },
            guardarModalRango() {
                try {
                    if (!this.$refs.form_modal_rango.validate()) throw mensajeEstandar.corregirInformacion;
                    if (this.objModalRango.valor != this.objModalRango.rangoInicial) throw mensajeEstandar.valorCoberturaIgualRango;
                    if (_.toNumber(this.objModalRango.rangoInicial) > _.toNumber(this.objModalRango.rangoFinal)) throw mensajeEstandar.rangoIncorrecto;

                        if (_.isUndefined(this.objModalRango.index)) {
                            if (this._validarInformacion(this.listGeneral.subDetalle, null, this.objModalRango.idCoberturaNueva, 'idCoberturaNueva')) throw mensajeEstandar.registroExistente;
                        } else
                        if (this._validarInformacion(this.listGeneral.subDetalle, this.objModalRango.index, this.objModalRango.idCoberturaNueva, 'idCoberturaNueva')) throw mensajeEstandar.registroExistente;


                        var cobertura = _.find(this.listGeneral.listCoberturasModal, (o) => { return parseInt(o.idCobertura) == parseInt(this.objModalRango.idCoberturaNueva) });
                        this.objModalRango.cobertura = _.size(cobertura) > 0 ? cobertura.cobertura : '';

                        if (!_.isUndefined(this.objModalRango.index)) {
                            this.listGeneral.subDetalle[this.objModalRango.index] = _.merge(
                                                                                            this.listGeneral.subDetalle[this.objModalRango.index], 
                                                                                            _.omit(this.objModalRango, ['titulo', 'abrirDialogo','index',])
                                                                                            );
                        } else {
                            this.listGeneral.subDetalle.push(_.omit(this.objModalRango, ['titulo', 'abrirDialogo']));
                        }

                        this.objModalRango = {
                            titulo: 'Nuevo Rango',
                            abrirDialogo: false,
                            idCoberturaNueva:null,
                            valor:null,
                            rangoInicial:null,
                            rangoFinal:null,
                            intervalo:null,
                            idClasificacionCob:null,
                            idEstado: _.toString(this.parametros.idEstadoDefault)
                        };
                } catch (e) {
                    mensajesAlerta(e, 'I')
                }
            },
        }
    }
</script>